import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FavoriteButton, Layout, SiteNav } from '@vwfs-bronson/bronson-react';
import { loginAsOutlet } from '../../../services/api/authorization';
import { storage } from '../../../services/localStorage';
import { brokerSelectors, setFavouriteCompanyId } from '../../../services/redux/features/broker.slice';
import { getCompanyDisplayText } from './utils';

type Props = {
  company: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData;
};

export const CompanyListItemForNavDropdown: FunctionComponent<Props> = ({ company }) => {
  const selectedCompany = useSelector(brokerSelectors.currentCompany);
  const favouriteCompanyId = useSelector(brokerSelectors.favouriteCompanyId);
  const dispatch = useDispatch();

  const itemText = getCompanyDisplayText(company);
  const companyIsSelected = company.milesCompanyId === selectedCompany?.milesCompanyId;
  const companyIsFavourite = favouriteCompanyId === company.milesCompanyId;

  return (
    <Layout middle center className="u-p-xsmall">
      <Layout.Item default="3/4">
        <SiteNav.Item.DropdownItem
          className="u-text-wrap u-mb-none"
          active={companyIsSelected}
          href=""
          onClick={(e) => {
            e.preventDefault();
            loginAsOutlet(company.milesCompanyId!, true);
          }}
        >
          {itemText}
        </SiteNav.Item.DropdownItem>
      </Layout.Item>
      <Layout.Item default="1/4">
        <FavoriteButton
          /* To be changed when Bronson allows icon color customization */
          style={{ '--fav-button-color': '#FFFFFF' } as any}
          active={companyIsFavourite}
          iconOnly
          onPressedChange={() => {
            if (companyIsFavourite) {
              dispatch(setFavouriteCompanyId(undefined));
              storage.favouriteCompanyId = undefined;
            } else {
              dispatch(setFavouriteCompanyId(company.milesCompanyId!));
              storage.favouriteCompanyId = company.milesCompanyId;
            }
          }}
        />
      </Layout.Item>
    </Layout>
  );
};
